import React, { useState } from 'react'
import { ErrorMessage, Field } from 'formik'
import TextError from './TextError'
import { useStyles } from './styles'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { Checkbox } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined'
const CheckBoxField = (props) => {
  const classes = useStyles()
  const { label, name, checked, onValueChange, ...rest } = props
  return (
    <>
      <div className={classes.formCheckboxField}>
        <Checkbox
          icon={<CheckBoxOutlineBlankIcon fontSize="small" color="primary" />}
          checkedIcon={
            <CheckBoxOutlinedIcon fontSize="small" color="primary" />
          }
          name={name}
          checked={checked}
          onChange={() => {
            onValueChange(!checked)
          }}
          style={{ padding: '0' }}
        />
        <InputLabel
          style={{ fontWeight: 'bold', fontSize: '1em', marginLeft: '1em' }}
        >
          I confirm the following :
        </InputLabel>
      </div>

      <InputLabel htmlFor={name}>
        <ul>
          <li className={classes.formCheckboxLabel}>
            I am authorized to submit the documents that I have uploaded using
            this site, and have received permission from the applicant to submit
            this information to Enphase on the applicant’s behalf.
          </li>
          <li className={classes.formCheckboxLabel}>
            I have read and understand{' '}
            <a
              href="https://enphase.com/privacy"
              target="_blank"
              style={{ color: '#ff8c00' }}
            >
              Enphase’s Privacy Policy{' '}
            </a>{' '}
            and{' '}
            <a
              href="https://enphase.com/terms"
              target="_blank"
              style={{ color: '#ff8c00' }}
            >
              Terms of Service
            </a>{' '}
            (the “Policies”).{' '}
          </li>
          <li className={classes.formCheckboxLabel}>
            The applicant has acknowledged that they have read and understand
            the Policies.{' '}
          </li>
        </ul>
      </InputLabel>
    </>
  )
}

export default CheckBoxField
